/*jslint node: true */
'use strict';

import cookies from './cookies';

const globals = {
  months: ['Tammikuu', 'Helmikuu', 'Maaliskuu', 'Huhtikuu', 'Toukokuu', 'Kesäkuu', 'Heinäkuu', 'Elokuu', 'Syyskuu', 'Lokakuu', 'Marraskuu', 'Joulukuu'],
  weekdays: ['Maanantai', 'Tiistai', 'Keskiviikko', 'Torstai', 'Perjantai', 'Lauantai', 'Sunnuntai'],
  loggedUser: cookies.getCookie('loggedIn') ? JSON.parse(decodeURIComponent(cookies.getCookie('loggedIn'))) : false,

  /**
   * Check is user logged in to Omalaakkonen
   * @return {*} If user is logged in an object is returned, otherwise falsy value is returned.
   */
  islogged: () => {
    const loggedInCookie = cookies.getCookie('loggedIn');

    let result;

    if( loggedInCookie ) {
      try {
        result = JSON.parse(decodeURIComponent(loggedInCookie))
      } catch( error ) {
        console.error('Error encoding')
      }
    }

    return result;
  },
  isMobile: (() => {

    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth < 1024) {
      return true;
    } else {
      return false;
    }

  })(),
  isMobileOS: (() => {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      document.querySelector('body').classList.add('mobileos');
      return true;
    } else {
      return false;
    }
  })(),
};

window.globals = globals;

export default globals;
